import { TagList } from "common/component/TagList";
import { fromStyleLocals } from "common/css";
import { ContactDto, SearchCriteria } from "common/types/contact";
import { h } from "preact";

import * as stylesheet from "common/component/TagList/TagList.less";
const css = fromStyleLocals(stylesheet.locals);

export class ContactTagList extends TagList<ContactDto, SearchCriteria> {
  protected renderTag(
    onRemove: (item: ContactDto) => void,
    tags: ContactDto[]
  ): any {
    return tags.map(item => (
      <li class={css("tag")}>
        <span class={css("label", "")}>
          <span class={css("ellipsis")}>
            {item.firstname + " " + item.lastname}
          </span>
          <i onClick={() => onRemove(item)} class={css("fa", "fa-close")} />
        </span>
      </li>
    ));
  }

  protected renderSelectBy(
    selectedSearchBy: string,
    disabled: boolean
  ): JSX.Element {
    return (
      <div class={css("select-by")}>
        <select
          class={css("form-control")}
          disabled={disabled}
          onChange={this.onSearchLast}
          ref={by => (this.by = by as HTMLSelectElement)}
        >
          <option value="">By name</option>
          <option
            selected={selectedSearchBy === "email" ? true : false}
            value="email:"
          >
            By Email
          </option>
        </select>
      </div>
    );
  }
}
